import { SvgIcon, SvgIconProps } from '@mui/material';

export function ExitFullscreenIcon(props: SvgIconProps): React.JSX.Element {
  return (
    <SvgIcon viewBox="0 0 42 42" {...props}>
      <path
        clipRule="evenodd"
        d="M27.9108 12.9107C28.2362 12.5853 28.7638 12.5853 29.0893 12.9107C29.4147 13.2361 29.4147 13.7638 29.0893 14.0892L24.6785 18.5H27.6667C28.1269 18.5 28.5 18.8731 28.5 19.3333C28.5 19.7935 28.1269 20.1666 27.6667 20.1666H22.6667C22.2064 20.1666 21.8334 19.7935 21.8334 19.3333V14.3333C21.8334 13.8731 22.2064 13.5 22.6667 13.5C23.1269 13.5 23.5 13.8731 23.5 14.3333V17.3214L27.9108 12.9107ZM13.5 22.6666C13.5 22.2064 13.8731 21.8333 14.3334 21.8333H19.3334C19.7936 21.8333 20.1667 22.2064 20.1667 22.6666V27.6666C20.1667 28.1269 19.7936 28.5 19.3334 28.5C18.8731 28.5 18.5 28.1269 18.5 27.6666V24.6785L14.0893 29.0892C13.7638 29.4147 13.2362 29.4147 12.9108 29.0892C12.5853 28.7638 12.5853 28.2361 12.9108 27.9107L17.3215 23.5H14.3334C13.8731 23.5 13.5 23.1269 13.5 22.6666Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
}
